import { Box, Button, Heading, Text } from '@zillow/constellation-10';
import type { ReactNode } from 'react';
import MagnifyingGlassUsersSvg from './MagnifyingGlassUsersSvg';

type ModalState = {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
};

type AddTenantsProps = {
  onAddTenantsClick: () => void;
};

const CONTENT = {
  TITLE: 'Verify proof of renters insurance',
  LABEL: 'Add tenants',
  HELP: "There aren't any tenants associated with this property yet. Add them first, and then you can request proof of renters insurance. ",
  CTA: 'Add tenants',
} as const;

export const AddTenants = ({ onAddTenantsClick }: AddTenantsProps): ModalState => {
  const header = (
    <Heading data-testid="ProofRecomendedActions-Header" level={2}>
      {CONTENT.TITLE}
    </Heading>
  );

  const body = (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'default',
        padding: 'default',
      }}
    >
      <Box css={{ padding: 'tighter' }}>
        <MagnifyingGlassUsersSvg />
      </Box>
      <Text textStyle="heading-sm">{CONTENT.LABEL}</Text>
      <Text>{CONTENT.HELP}</Text>
    </Box>
  );

  const footer = (
    <Button
      data-testid="ProofRecomendedActions-AddTenantsButton"
      tone="brand"
      emphasis="filled"
      size="md"
      onClick={onAddTenantsClick}
    >
      {CONTENT.CTA}
    </Button>
  );

  return { header, body, footer };
};
